import UserProfileLayout from "./UserProfileLayout";
export default UserProfileLayout;
